import { inject } from 'vue'
import { providerKey } from './context'
import type { DialogProvider } from './types'

function useAppDialog() {
  const provider = inject<DialogProvider>(providerKey)

  if (!provider) {
    throw new Error('No outer <DialogProvider /> founded.')
  }

  return provider
}

export default useAppDialog
